var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-form-item',{attrs:{"label":_vm.$t('是否只读')}},[_c('el-switch',{model:{value:(_vm.data.disabled),callback:function ($$v) {_vm.$set(_vm.data, "disabled", $$v)},expression:"data.disabled"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }